export default {
  en: {
    setting: 'Setting',
    general: 'General',
    edit: 'Edit',
    currency: 'Currency',
    contractRefCodeFormat: 'Contract Ref Code Format',
    specialOfferRefCodeFormat: 'Special Offer Ref Code Format'
  },
  th: {
    setting: 'การตั้งค่า',
    general: 'ข้อมูลพื้นฐาน',
    edit: 'แก้ไข',
    currency: 'สกุลเงิน',
    contractRefCodeFormat: 'รูปแบบรหัสอ้างอิงสัญญา',
    specialOfferRefCodeFormat: 'รูปแบบรหัสอ้างอิงสำหรับข้อเสนอพิเศษ'
  }
}
